// extracted by mini-css-extract-plugin
export var arrows = "_5i-6";
export var decrementer = "_5i-a";
export var disabled = "_5i-4";
export var error = "_5i-1";
export var hiddenText = "_5i-b";
export var incrementer = "_5i-9";
export var input = "_5i-8";
export var inputWrapper = "_5i-0";
export var leadingIcon = "_5i-c";
export var readonly = "_5i-3";
export var regular = "_5i-7";
export var small = "_5i-5";
export var warning = "_5i-2";